import { Box, type BoxProps, Container, type ContainerProps, type Theme, useMediaQuery } from '@mui/material';
import 'driver.js/dist/driver.css';
import type Header from '../header';
import type HeroHeader from '../hero-header';

const PageContainer = ({
    boxChildren,
    heroHeader,
    header,
    children,
    boxProps,
    containerProps,
    grayBackground,
}: {
    boxChildren?: React.ReactNode;
    heroHeader?: ReturnType<typeof HeroHeader>;
    header?: ReturnType<typeof Header>;
    boxProps?: BoxProps;
    containerProps?: ContainerProps;
    children: React.ReactNode;
    grayBackground?: boolean;
}) => {
    const isXsOrLower = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
    return (
        <Box {...boxProps}>
            {heroHeader && heroHeader}
            {boxChildren && boxChildren}
            {grayBackground && (
                <Box
                    sx={{
                        backgroundColor: 'grey.100',
                        height: 250,
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        zIndex: -1,
                    }}
                />
            )}
            <Container maxWidth={'xl'} sx={[isXsOrLower ? { pt: 2, pb: 2 } : { pt: 5, pb: 2 }]} {...containerProps}>
                {header && header}
                {children}
            </Container>
        </Box>
    );
};

export default PageContainer;
